export const SET_ACCOUNT_ID = 'SET_ACCOUNT_ID';
export const SET_LOCATIONS_DATA = 'SET_LOCATIONS_DATA';
